import { render, staticRenderFns } from "./messageTemplateModal.vue?vue&type=template&id=6faa3d68&scoped=true"
import script from "./messageTemplateModal.vue?vue&type=script&lang=js"
export * from "./messageTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./messageTemplateModal.vue?vue&type=style&index=0&id=6faa3d68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa3d68",
  null
  
)

export default component.exports